var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count-down"},[_c('div',{staticClass:"iconfont icon"},[_vm._v("")]),_c('div',{staticClass:"hint"},[_vm._v(_vm._s(_vm.timeText))]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.countDownList))])])
}
var staticRenderFns = []

export { render, staticRenderFns }